import Modal from "../../common/modal";

import ButtonText from "../../common/buttonText";
import { useTranslation } from "react-i18next";
import InputText from "../../common/inputText";
import { useState } from "react";

export const PermitManualActivationModal = ({
  display,
  setDisplay,
  onSubmit
}) => {
  const { t } = useTranslation();

  const [permitUser, setPermitUser] = useState({
    email: "",
    firstName: "",
    lastName: "",
    licencePlate: "",
  });
  return (
    <Modal
      title={t('createPermitPage.activateManualPermit')}
      overlayClassName={"items-center justify-center"}
      modalClassName={"max-h-[96vh] overflow-y-auto flex-col z-50"}
      innerClassName={"w-[95vw] md:w-[20vw] overflow-y-auto"}
      display={display}
      setDisplay={setDisplay}
    >
    <div className="flex flex-col gap-2">
      <InputText
        placeHolder={t("permitTable.email")}
        title={t("permitTable.email")}
        value={permitUser.email}
        onChange={(value) => {setPermitUser({...permitUser, email: value})}}
        required
      />
      <InputText
        placeHolder={t("permitTable.firstName")}
        title={t("permitTable.firstName")}  
        value={permitUser.firstName}
        onChange={(value) => {setPermitUser({...permitUser, firstName: value})}}
        required
      />
      <InputText
        placeHolder={t("permitTable.lastName")}
        title={t("permitTable.lastName")}
        value={permitUser.lastName}
        onChange={(value) => {setPermitUser({...permitUser, lastName: value})}}
        required
      />
      <InputText
        placeHolder={t("permitTable.licensePlateNumber")}
        title={t("permitTable.licensePlateNumber")}
        value={permitUser.licencePlate}
        onChange={(value) => {setPermitUser({...permitUser, licencePlate: value})}}
        required
      />
    </div>

      <ButtonText
        disabled={!permitUser.email || !permitUser.firstName || !permitUser.lastName || !permitUser.licencePlate}
        onClick={() => {
            onSubmit(permitUser);
        }}
        className="flex mt-6 justify-center ml-auto"
      >
        {t("permitQueueItemModal.buttonSave")}
      </ButtonText>
    </Modal>
  );
};
